import { getErrorMessage } from 'application/util/error.util';

import './forgot-password-request.style.sass';
import template from './forgot-password-request.tpl.pug';

class ForgotPasswordRequestController {
    /* @ngInject */
    constructor($state, $stateParams, resetPasswordService) {
        this.$state = $state;
        this.resetPasswordService = resetPasswordService;

        this.email = $stateParams.email || null;
    }

    send(email) {
        return this.resetPasswordService.send(email).then(() => {
            this.$state.go('identity.forgot-password.confirm');
        }, (result) => {
            this.error = getErrorMessage(result, `We were not able to send you the email.`);
        });
    }
}

export default {
    selector: 'dbAForgotPasswordRequest',
    template: template(),
    controller: ForgotPasswordRequestController
};



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-request/forgot-password-request.cmpt.js